import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { getRTL } from '@yme/selectors/common';
import { HeadingLevel2 } from '@yme/tokens/typography';
import Video from '../Video';
import { TitleStyled } from './styled';
export function NewsEventsVideo(props) {
    const { title, previewImage, youtubeId, isPlaylistId, cqPath, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    const { isMobileView } = useWindowSize();
    if (!youtubeId) {
        return null;
    }
    if (isMobileView) {
        return (React.createElement(React.Fragment, null,
            title && (React.createElement(TitleStyled, { isRightToLeft: isRightToLeft },
                React.createElement(HeadingLevel2, null, title))),
            React.createElement(Video, { youtubeId: youtubeId, previewImage: previewImage, isPlaylistId: isPlaylistId, isCustomGrid: false, isInEditor: false, cqPath: cqPath, isRemoveBottomIndent: isRemoveBottomIndent })));
    }
    return (React.createElement(Container, null,
        React.createElement(Row, { justifyContent: "center" },
            React.createElement(Col, { lg: 8, md: 8 },
                title && (React.createElement(TitleStyled, { isRightToLeft: isRightToLeft },
                    React.createElement(HeadingLevel2, null, title))),
                React.createElement(Video, { youtubeId: youtubeId, previewImage: previewImage, isPlaylistId: isPlaylistId, isCustomGrid: false, isInEditor: false, cqPath: cqPath, isRemoveBottomIndent: isRemoveBottomIndent })))));
}
NewsEventsVideo.displayName = 'NewsEventsVideo_AEMComponent';
